<template>
  <div class="-mx-6 sm:mx-0 event-track-search">
    <div class="track-search mb-8">
      <mj-spotify-search-tracks
        @found-tracks="results = $event"
        @next-tracks="nextTracks = $event"
        @total="total = $event"
      />
    </div>
    <div
      v-if="results.length > 0"
      class="search-results"
    >
      <mj-track-list
        :tracks="computedResults"
        :stored-tracks="currentTracks"
        @track-selected="sync"
      />
      <div class="text-center">
        <mj-spotify-load-more-tracks
          :next="nextTracks"
          @new-tracks="results.push(...$event)"
          @next-tracks="nextTracks = $event"
        />
      </div>
    </div>
    <mj-tracks-table-content-placeholder
      v-else
      :is-dirty="isDirty"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import TrackMapper from '@/services/mapper/TrackMapper';
import TracksTableContentPlaceholder from '@/components/tracks/table/TracksTableContentPlaceholder.vue';
import SpotifySearchTracks from '@/components/spotify/SpotifySearchTracks.vue';
import SpotifyLoadMoreTracks from '@/components/spotify/SpotifyLoadMoreTracks.vue';
import TrackList from '@/components/tracks/TrackList.vue';

export default {
  name: 'EventTrackSearch',

  components: {
    'mj-tracks-table-content-placeholder': TracksTableContentPlaceholder,
    'mj-spotify-search-tracks': SpotifySearchTracks,
    'mj-spotify-load-more-tracks': SpotifyLoadMoreTracks,
    'mj-track-list': TrackList,
  },

  data() {
    return {
      results: [],
      // isDirty: false,
      nextTracks: null,
      total: -1,
    };
  },

  computed: {
    ...mapGetters(['currentEvent', 'isDefaultUser']),

    currentTracks() {
      return this.currentEvent.playlist.tracks;
    },

    computedResults() {
      return TrackMapper.mapSpotifyTracksToTracksTable(this.results);
    },

    isDirty() {
      if (this.total === 0) {
        return true;
      }
      return false;
    },
  },

  methods: {
    ...mapActions(['toggleTrack']),

    sync(track) {
      const currentTrack = {
        ...track,
      };

      if (this.isDefaultUser) {
        // eslint-disable-next-line camelcase
        currentTrack.is_transferred = true;
      } else {
        // eslint-disable-next-line camelcase
        currentTrack.is_transferred = false;
      }

      this.toggleTrack(currentTrack)
        .then()
        .catch(error => {
          console.error(error);
        });
    },
  },

};

</script>
